import styled from "styled-components";

const Wrapper = styled.div`
    width: 95%;
    margin: 0 auto;
    max-width: 1312px;
`

export default Wrapper;